import { getInputType } from "../utils/utils";

export type props = {
  list: any[];
  handleCallback: (id: string, value: string) => void;
  handleCheckboxCallback: (
    id: string,
    optionId: string,
    value: boolean
  ) => void;
  handleUploadImageCallback: (id: string, mime: string, file: string) => void;
  mode?: "form" | "graphic" | "hybrid";
  marketplaceId?: string;
  documentId?: string;
};

const ComponentList = ({
  list,
  handleCallback,
  handleCheckboxCallback,
  handleUploadImageCallback,
  mode,
  marketplaceId,
  documentId,
}: props) => {
  return (
    <>
      {list.map((comp: any, index: number) =>
        getInputType(
          comp,
          index,
          handleCallback,
          handleCheckboxCallback,
          handleUploadImageCallback,
          mode,
          marketplaceId,
          documentId
        )
      )}
    </>
  );
};

export default ComponentList;
